import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box, Typography, FormControlLabel, Switch,
} from '@mui/material';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';
import {
  PARTS_TAB_PROPERTY_NAME, WORK_ITEM_PARTS_TAB_PROPERTY_NAME, PART_FILES_TAB_PROPERTY_NAME,
} from '../../../components/Parts/partsUtils';

const PLUGINS = [
  { name: PARTS_TAB_PROPERTY_NAME, label: 'Show the vehicle Parts section on this tab' },
  { name: WORK_ITEM_PARTS_TAB_PROPERTY_NAME, label: 'Show Parts inside each expanded work item on this tab' },
  { name: PART_FILES_TAB_PROPERTY_NAME, label: 'Allow files/photos to be attached to each part row' },
];

const TabPluginToggles = ({ tab }) => {
  const dispatch = useDispatch();
  const properties = tab?.tab_properties || [];

  const toggle = (name, checked) => {
    const existing = properties.find(p => p.name === name);
    if (checked && !existing) {
      dispatch(addTabProperty({ tab_id: tab.id, name }, 'addTabProperty'));
    } else if (!checked && existing) {
      dispatch(deleteTabProperty(existing.id, 'deleteTabProperty'));
    }
  };

  if (!tab?.id) return null;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Tab Components</Typography>
      {PLUGINS.map(plugin => (
        <FormControlLabel
          key={plugin.name}
          control={(
            <Switch
              checked={properties.some(p => p.name === plugin.name)}
              onChange={e => toggle(plugin.name, e.target.checked)}
            />
          )}
          label={plugin.label}
        />
      ))}
    </Box>
  );
};

export default TabPluginToggles;
